import { Box } from '@mui/material';
import React from 'react';
import { ColorPaper } from '../ColorPaper';
export const PageHeader = ({ gradient, children }) => {
    return (React.createElement(ColorPaper, { gradient: gradient },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: { xs: 'flex-start', lg: 'center' },
                width: '100%',
                gap: { lg: 3 },
            }, "data-test": 'page-header' }, children)));
};
